import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { TituloReceberPerspectiva, tituloReceberPerspectivas } from '../titulo-receber-perspectiva';

@Component({
    selector: 'sgt-titulo-receber-perspectiva-select',
    templateUrl: './titulo-receber-perspectiva-select.component.html',
    styleUrls: ['./titulo-receber-perspectiva-select.component.less']
})
export class TituloReceberPerspectivaSelectComponent implements OnInit, OnChanges {
    perspectivas = tituloReceberPerspectivas;

    /** Perspectiva */
    @Input() idPerspectiva: number;
    /** Ao alterar a perspectiva */
    @Output() idPerspectivaChange = new EventEmitter<number>();
    /** Perspectiva selecionada */
    perspectiva: TituloReceberPerspectiva;
    /** Perspectiva alterada */
    @Output() perspectivaChange = new EventEmitter<TituloReceberPerspectiva>();
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    ngOnInit(): void {
        this.setPeriodicidade();
    }

    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (propName === 'idPerspectiva') {
                if (!changes[propName].isFirstChange()) {
                    this.setPeriodicidade();
                }
            }
        }
    }

    private setPeriodicidade() {
        this.perspectiva = this.perspectivas.find(perspectivaFilter => perspectivaFilter.id == this.idPerspectiva);
    }

    /** Ao selecionar a perpectiva */
    select(perspectiva: TituloReceberPerspectiva) {
        this.idPerspectiva = perspectiva ? perspectiva.id : null;
        this.idPerspectivaChange.emit(this.idPerspectiva);
        this.perspectiva = perspectiva;
        this.perspectivaChange.emit(this.perspectiva)
    }
}
